<template>
  <a-drawer title="计划详情" placement="right" destroy-on-close :closable="false" :width="700" :get-container="pageContainer" :wrap-style="{ position: 'absolute' }" :body-style="{ padding: '16px 16px 60px', height: 'calc(100% - 44px)', overflowY: 'auto' }" :visible="visible" @close="close">
    <div class="task-container">
      <div class="page-steps w800">
        <a-steps size="small" progress-dot class="v-my-lg" :current="currentStep">
          <a-step title="任务成果提交" />
          <a-step title="项目官员审核" v-if="data.ownerType == 2" />
          <a-step title="项目主管终审" />
          <a-step title="任务完成" />
        </a-steps>
      </div>
      <a-alert class="v-mb-sm no-border" type="error" v-if="data.checkResult == -1">
        <div slot="message">
          <div class="font-md text-darkblue flex items-center"><a-icon type="alert" class="v-mr-xs" />提交的任务成果已被驳回</div>
          <div class="flex v-mt-xs">
            <span class="text-right text-grey">审核意见：</span>
            <span class="col text-red" v-html="$utils.convertToHtml(data.checkOpinion)"></span>
          </div>
        </div>
      </a-alert>
      <table class="table table-plain table-fixed">
        <tbody>
          <tr>
            <th width="140">任务状态</th>
            <td>
              <span v-if="data.taskState == 0">未开始</span>
              <span v-else-if="data.taskState == 1">进行中</span>
              <span v-else-if="data.taskState == 2">已完成</span>
            </td>
          </tr>
          <tr>
            <th>任务名称</th>
            <td>{{ data.taskName }}</td>
          </tr>
          <tr>
            <th>计划周期</th>
            <td>{{ data.startDate ? data.startDate + ' ~ ' + data.endDate : '' }}</td>
          </tr>
          <tr v-if="data.checkState || data.checkResult == -1">
            <th>成果提交时间</th>
            <td>{{ data.submitTime ? data.submitTime.substring(0, 16) : '' }}</td>
          </tr>
          <tr>
            <th>实际开始日期</th>
            <td>
              <a-date-picker size="default" placeholder="开始日期" v-model="data.actualStartDate" ref="actualStartDate" style="width: 150px" :disabled-date="disabledStartDate" format="YYYY-MM-DD" value-format="YYYY-MM-DD" v-if="unsubmited" />
              <template v-else>{{ data.actualStartDate ? data.actualStartDate.substring(0, 10) : '' }}</template>
            </td>
          </tr>
          <tr>
            <th>实际结束日期</th>
            <td>
              <a-date-picker size="default" placeholder="结束日期" v-model="data.actualEndDate" ref="actualEndDate" style="width: 150px" :disabled-date="disabledEndDate" format="YYYY-MM-DD" value-format="YYYY-MM-DD" v-if="unsubmited" />
              <template v-else>{{ data.actualEndDate ? data.actualEndDate.substring(0, 10) : '' }}</template>
            </td>
          </tr>
          <tr>
            <th>文件类型</th>
            <td>
              <a-select placeholder="选择文件类型" v-model="data.outcomeType" ref="outcomeType" style="width: 150px" v-if="unsubmited">
                <a-select-option :value="1">月报</a-select-option>
                <a-select-option :value="2">季报</a-select-option>
                <a-select-option :value="3">年报</a-select-option>
                <a-select-option :value="4">重大活动报告</a-select-option>
                <a-select-option :value="5">其他</a-select-option>
              </a-select>
              <template v-else>
                <span v-if="data.outcomeType == 1">月报</span>
                <span v-else-if="data.outcomeType == 2">季报</span>
                <span v-else-if="data.outcomeType == 3">年报</span>
                <span v-else-if="data.outcomeType == 4">重大活动报告</span>
                <span v-else-if="data.outcomeType == 5">其他</span>
              </template>
              <!-- <a-select placeholder="选择报告类型" v-model="form.outcomeType" style="width: 300px" ref="type">
                <a-select-option :value="1">月报</a-select-option>
                <a-select-option :value="2">季报</a-select-option>
                <a-select-option :value="3">年报</a-select-option>
                <a-select-option :value="4">重大活动报告</a-select-option>
              </a-select> -->
            </td>
          </tr>
          <tr>
            <th valign="top">项目文件</th>
            <td>
              <a-upload-dragger
                multiple
                :action="`${baseURL}/file/upload`"
                :data="{
                  params: JSON.stringify({ projectId: data.projectId, fileBelongId: data.taskId, fileType: 7, fileSign: 'P01' }),
                }"
                :file-list="fileList"
                :before-upload="beforeUploadFile"
                @preview="handlePreviewFile"
                @change="info => handleUploadChange(info, -1)"
                accept=".doc, .docx, .xls, .xlsx, .pdf, .ppt, .pptx, .png, .jpg, .jpeg, .gif"
                class="uploader-md"
                ref="fileList"
                v-if="unsubmited"
              >
                <p class="ant-upload-drag-icon">
                  <a-icon type="upload" />
                </p>
                <p class="ant-upload-text">点击选择或拖拽文件至此区域上传<br /><span class="text-grey"></span></p>
              </a-upload-dragger>
              <template v-else>
                <file-container :img-size="[100, 55]" :files="data.files" :belongId="data.projectId" fileSign="P01" v-if="data.projectId && data.files"></file-container>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        :style="{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e8e8e8',
          padding: '8px 16px',
          textAlign: 'right',
          left: 0,
          background: '#fff',
          borderRadius: '0 0 4px 4px',
        }"
      >
        <a-space>
          <a-button icon="close" @click="close">关闭</a-button>
          <template v-if="isProcessable(data.checkState)">
            <a-button icon="rollback" type="indigo" :loading="saving" @click="handleReviewBackConfirm">驳回</a-button>
            <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmReview" v-if="data.checkState == 1">审核通过，提交主管审核</a-button>
            <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmReview" v-else-if="data.checkState == 2">审核通过</a-button>
          </template>
          <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmSubmit" v-else-if="!data.checkState && data.ownerType == 1">提交任务成果</a-button>
        </a-space>
      </div>
    </div>
    <a-modal centered title="驳回任务成果" :visible="rejectModal" @cancel="cancelRejectModal" width="550px" :body-style="{ padding: '12px' }">
      <template slot="footer">
        <a-space>
          <a-button @click="cancelRejectModal">取消</a-button>
          <a-button type="indigo" :loading="saving" @click="handleReview(false, 0)" v-if="[1, 2].includes(data.checkState)">确认驳回，退回至申请人</a-button>
          <a-button type="indigo" :loading="saving" @click="handleReview(false, data.checkState - 1)" v-if="data.ownerType == 2 && [2, 3].includes(data.checkState)">确认驳回，退回至官员</a-button>
        </a-space>
      </template>
      <a-textarea v-model="rejectReason" :rows="6" placeholder="输入驳回原因" ref="rejectReason" />
    </a-modal>
  </a-drawer>
</template>

<script>
import { submitTaskArchive, reviewTaskArchive } from '@/api/project/common'
export default {
  name: 'Task',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    task: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      currentStep: 0,
      saving: false,
      data: {},
      form: {
        actualStartDate: undefined,
        actualEndDate: undefined,
        outcomeType: undefined,
        fileIds: [],
      },
      fileList: [],
      rejectModal: false,
      rejectReason: '',
    }
  },
  computed: {
    unsubmited() {
      let { checkState, ownerType } = this.data
      return !checkState && ownerType == 1
    },
  },
  watch: {
    task() {
      this.data = { ...this.task }
      let { projectId, checkState, ownerType, files } = this.task
      if (!checkState) {
        this.currentStep = 0
      } else if (checkState == 9) {
        this.currentStep = ownerType == 2 ? 3 : 2
      } else {
        this.currentStep = ownerType == 2 ? checkState : checkState - 1
      }
      this.fileList = files.map(file => ({
        ...file,
        uid: file.fileId,
        name: file.fileOriginName,
        fileSign: 'P01',
        belongId: projectId,
        status: 'done',
      }))
    },
    visible() {
      this.$emit('input', this.visible)
      this.$emit('change', this.visible)
    },
    value() {
      this.visible = this.value
    },
  },
  methods: {
    // loadTask() {
    //   this.loading = true
    //   getTaskInfo(this.id).then(({ data }) => {
    //     if (data.success) {
    //       this.data = data.data
    //       let { state, taskConfirmType, startDate, endDate, remark, fileName } = data.data
    //       this.form = {
    //         ...this.form,
    //         startDate,
    //         endDate,
    //         remark,
    //         fileName,
    //       }
    //       if (taskConfirmType == '0' || taskConfirmType == '1') {
    //         if (state == '2' || state == '3') {
    //           this.currentStep = 1
    //         } else if (state == '4' || state == '5') {
    //           this.currentStep = 2
    //         }
    //       } else if (taskConfirmType == '2') {
    //         if (state == '2') {
    //           this.currentStep = 1
    //         } else if (state == '3') {
    //           this.currentStep = 2
    //         } else if (state == '4' || state == '5') {
    //           this.currentStep = 3
    //         }
    //       }
    //     }
    //   })
    // },
    close() {
      this.visible = false
      this.$emit('close')
    },
    disabledStartDate(startValue) {
      let isValid = true
      let { actualEndDate } = this.data
      let startTime = startValue.startOf('day').valueOf()
      // isValid = startTime <= this.$moment().endOf('day').valueOf()
      if (isValid && actualEndDate) {
        isValid = startTime <= this.$moment(actualEndDate).valueOf()
      }
      return !isValid
    },
    disabledEndDate(endValue) {
      let isValid = true
      let { actualStartDate } = this.data
      let endTime = endValue.startOf('day').valueOf()
      // isValid = endTime <= this.$moment().endOf('day').valueOf()
      if (isValid && actualStartDate) {
        isValid = endTime >= this.$moment(actualStartDate).valueOf()
      }
      return !isValid
    },
    handleUploadChange(info, count) {
      this.fileList = this.handleUploadFile(info, count)
      this.$refs.fileList.$el.classList.remove('uploader-empty')
    },
    handleConfirmSubmit() {
      this.$message.destroy()
      let { outcomeType, actualStartDate, actualEndDate } = this.data
      // if (!outcomeType) {
      //   this.$message.warn('请选择报告类型')
      //   this.$refs.outcomeType.focus()
      //   return
      // }
      // if (this.fileList.length == 0) {
      //   this.$message.warn('请上传报告文件')
      //   this.$refs.fileList.$el.classList.add('uploader-empty')
      //   return
      // }
      this.$confirm({
        title: '确认提交任务成果？',
        centered: true,
        onOk: () => {
          this.handleSubmit()
        },
      })
    },
    handleSubmit() {
      this.$message.destroy()
      let { taskId, projectId, outcomeType, actualStartDate, actualEndDate } = this.data
      // if (!outcomeType) {
      //   this.$message.warn('请选择报告类型')
      //   this.$refs.outcomeType.focus()
      //   return
      // }
      // if (this.fileList.length == 0) {
      //   this.$message.warn('请上传报告文件')
      //   this.$refs.fileList.$el.classList.add('uploader-empty')
      //   return
      // }
      let params = {
        taskId,
        projectId,
        outcomeType,
        actualStartDate,
        actualEndDate,
        fileIds: this.fileList.filter(d => d.fileId).map(d => d.fileId),
      }
      this.saving = true
      submitTaskArchive(params).then(({ data }) => {
        this.saving = false
        if (data.success) {
          this.$message.success('操作成功')
          this.$emit('submit')
        } else {
          this.$message.warn(data.msg)
        }
      })
    },
    cancelRejectModal() {
      this.rejectModal = false
    },
    handleReviewBackConfirm() {
      this.rejectReason = ''
      this.rejectModal = true
    },
    handleConfirmReview() {
      this.$confirm({
        title: '确认审核通过？',
        centered: true,
        onOk: () => {
          this.handleReview(true)
        },
      })
    },
    handleReview(approved, backsteps = 0) {
      let { taskId, projectId } = this.data
      let { rejectReason } = this
      this.$message.destroy()
      if (!approved && rejectReason.trim() === '') {
        this.$message.warn('请输入驳回原因')
        this.$refs.rejectReason.focus()
        return
      }
      let params = {
        id: taskId,
        projectId,
        result: approved ? 1 : 0,
        backsteps,
        opinion: rejectReason.trim(),
      }
      this.saving = true
      reviewTaskArchive(params)
        .then(({ data }) => {
          this.saving = false
          if (data.success) {
            this.$message.success('操作成功')
            this.cancelRejectModal()
            this.$emit('submit')
          } else {
            this.$message.warn(data.msg)
          }
        })
        .catch(() => {
          this.saving = false
          this.$message.warn('操作失败')
        })
    },
  },
  created() {
    this.visible = this.value
    // this.load()
  },
  mounted() {},
}
</script>
